<template>
  <DialogYesNo
    title="Change quiz status"
    v-bind:visible="visible"
    @hidden="updateVmodel"
    @ok="submit"
  >
    <div v-if="quiz && canBeChanged">
      <p>
        You are about to change the state of this quiz to
        <span
          v-bind:class="'tq-status-' + nextStatus"
          class="font-weight-bold"
          >{{ nextStatusName }}</span
        >.
      </p>
      <p>{{ explain }}</p>
      <p class="text-muted text-medium">Note: This action cannot be undone.</p>
    </div>
    <div v-else>
      This quiz has been finalized. You can no longer change its status.
    </div>
  </DialogYesNo>
</template>

<script>
import DialogYesNo from "@/components/DialogYesNo";
import explanations from "@/assets/explanations.js";

export default {
  name: "DialogQuizStatus",
  props: {
    visible: {
      default: false
    },
    quiz: {}
  },
  components: {
    DialogYesNo
  },
  data() {
    return {
      myDate: "",
      myTime: ""
    };
  },
  computed: {
    canBeChanged() {
      return this.quiz.status < this.$tqConstants["QUIZ_STATUS_FINALIZED"];
    },
    nextStatus() {
      return this.quiz.status + 1;
    },
    nextStatusName() {
      return explanations.quiz_status_names[this.nextStatus];
    },
    explain() {
      return explanations.quiz_status_next[this.nextStatus];
    }
  },
  model: {
    prop: "visible",
    event: "hidden"
  },
  created() {},
  methods: {
    updateVmodel() {
      this.$emit("hidden", false);
    },
    submit(ev) {
      this.$emit("ok", ev, this.nextStatus);
    }
  }
};
</script>
